'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Skeleton_module = require('../styles/Skeleton.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Skeleton Button component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Button />
 * ```
 */
const Button = (props) => {
    const { block, className, inverted = false, ...restProps } = props;
    const cx = reactUtils.useStyles(Skeleton_module.default);
    const classNames = cx(className, 'button', { block, inverted });
    return React__namespace.createElement("div", { className: classNames, ...restProps });
};
Button.displayName = 'Button';

exports.Button = Button;
//# sourceMappingURL=Button.js.map
